import React, { FC, CSSProperties } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import smsIconPath from './paths';
import styles from './SmsAction.module.css';

export interface SmsActionIconProps {
  s?: CSSProperties;
}

const SmsActionIcon: FC<SmsActionIconProps> = ({ s = {} }) => {
  const { iconsPrimaryNone: iconStyle } = useTheme();
  const style = { ...iconStyle, ...s };

  return (
    <svg
      className={styles.container}
      style={{ fill: style.color, ...style }}
      viewBox="0 0 96 40"
      role="presentation"
    >
      <path d={smsIconPath} />
    </svg>
  );
};

export default SmsActionIcon;
